import React, { useState } from 'react'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import { Grid } from '@material-ui/core'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'
import ImageUpload from 'src/components/sharedComponents/CustomUpload/ImageUpload'
import { DatePicker } from '@material-ui/pickers'
import CircularProgress from '@material-ui/core/CircularProgress'

const ModalUploadFiles = (props) => {
  const [selectedDate, handleDateChange] = useState(new Date())
  const [files, setFiles] = useState([])

  const { open, handleClose, handleSaveUploadFile, section, loading } = props
  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          Seleccione un archivo PDF o EXCEL
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <Grid container spacing={2}>
              <Grid item xs={6}>
                {loading ? (
                  <>
                    <CircularProgress disableShrink />
                  </>
                ) : (
                  <>
                    <ImageUpload
                      captureImgBase64={(imagePreviewUrl) =>
                        setFiles({
                          ...imagePreviewUrl,
                          seccion: section.title,
                          yyyy: selectedDate.getFullYear(),
                          mm: selectedDate.getMonth(),
                        })
                      }
                      addButtonProps={{ round: false, size: 'sm' }}
                      changeButtonProps={{
                        round: false,
                        color: 'customAuteco',
                        size: 'sm',
                      }}
                      removeButtonProps={{
                        round: false,
                        color: 'danger',
                        size: 'sm',
                      }}
                    />
                  </>
                )}
              </Grid>
              <Grid item xs={6}>
                <h4>{section.title}</h4>
                <h6>Seleccione la fecha del reporte</h6>
                <br />
                <DatePicker
                  variant="inline"
                  openTo="year"
                  autoOk
                  views={['year', 'month']}
                  label="Año y mes"
                  value={selectedDate}
                  onChange={handleDateChange}
                />
              </Grid>
            </Grid>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Cancelar
          </Button>
          <Button
            onClick={() => handleSaveUploadFile(files)}
            color="primary"
            autoFocus
          >
            Guardar
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  )
}

export default ModalUploadFiles
